module.exports = __webpack_public_path__ + "img/team6.b97872ee.jpg";